
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/contelizer-easyitem-com/prestashop-rest-front/sentry.client.config.ts")
            }
          });